export default "__VITE_ASSET__YPRvzR45__"